var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { connect } from 'react-redux';
import { sportSortFunc } from '../../../../rendering-commons/Sorting';
import Sport from './Sport';
import { injectIntl, defineMessages } from 'react-intl';
var messages = defineMessages({
    grid_today: {
        id: "grid.today",
        defaultMessage: "Today"
    },
    grid_tomorrow: {
        id: "grid.tomorrow",
        defaultMessage: "Tomorrow"
    },
    grid_tomorrow_2: {
        id: "grid.tomorrow_2",
        defaultMessage: "Day after tomorrow"
    },
    grid_all_sports: {
        id: "grid.all_sports",
        defaultMessage: "All sports"
    }
});
var Timetable = /** @class */ (function (_super) {
    __extends(Timetable, _super);
    function Timetable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            showTimeFilterDD: false,
            showSportDD: false,
            date: moment.now(),
            timeSet: '0',
            timeFilter: _this.props.intl.formatMessage(messages.grid_today),
            sportId: undefined
        };
        _this.handleOutsideClick = function (event) {
            if (_this.node.contains(event.target)) {
                return;
            }
            if (event.target.id !== "date") {
                _this.setState({
                    showTimeFilterDD: false
                });
            }
        };
        _this.onChangeDate = function (e) {
            e.preventDefault();
            var timeSet = e.target.id;
            var date;
            switch (timeSet) {
                case '0':
                    _this.setState({
                        timeFilter: _this.props.intl.formatMessage(messages.grid_today),
                        timeSet: timeSet
                    });
                    date = moment(moment.now());
                    break;
                case '1':
                    _this.setState({
                        timeFilter: _this.props.intl.formatMessage(messages.grid_tomorrow),
                        timeSet: timeSet
                    });
                    date = moment().add(1, 'day');
                    break;
                case '2':
                    _this.setState({
                        timeFilter: _this.props.intl.formatMessage(messages.grid_tomorrow_2),
                        timeSet: timeSet
                    });
                    date = moment().add(2, 'day');
                    break;
            }
            _this.setState({
                date: date,
                timeSet: timeSet,
                showTimeFilterDD: false
            });
        };
        _this.onDropdownClick = function (e) {
            var _a, _b;
            e.preventDefault();
            var target = e.target.name;
            _this.state[target] === false ?
                _this.setState((_a = {},
                    _a[target] = true,
                    _a)) :
                _this.setState((_b = {},
                    _b[target] = false,
                    _b));
        };
        _this.onSportChange = function (e) {
            e.preventDefault();
            var sportId = +e.target.name;
            _this.setState({
                sportId: sportId,
                showSportDD: false
            });
        };
        return _this;
    }
    Timetable.prototype.componentWillMount = function () {
        document.addEventListener('click', this.handleOutsideClick, false);
    };
    Timetable.prototype.componentWillUnmount = function () {
        document.removeEventListener('click', this.handleOutsideClick, false);
    };
    Timetable.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.intl !== nextProps.intl)
            switch (this.state.timeSet) {
                case '0':
                    this.setState({ timeFilter: nextProps.intl.formatMessage(messages.grid_today) });
                    break;
                case '1':
                    this.setState({ timeFilter: nextProps.intl.formatMessage(messages.grid_tomorrow) });
                    break;
                case '2':
                    this.setState({ timeFilter: nextProps.intl.formatMessage(messages.grid_tomorrow_2) });
                    break;
            }
    };
    Timetable.prototype.renderSport = function (sport) {
        var name = sport.get('name');
        var id = sport.get('id');
        return (_jsx("li", __assign({ className: 'show' }, { children: _jsx("a", __assign({ href: '#', onClick: this.onSportChange, name: id }, { children: name })) }), id));
    };
    Timetable.prototype.render = function () {
        var _this = this;
        var _a = this.state, date = _a.date, timeFilter = _a.timeFilter, sportId = _a.sportId, showTimeFilterDD = _a.showTimeFilterDD, showSportDD = _a.showSportDD;
        var renderSports = [];
        var renderSportsName = [];
        var sports = this.props.sports;
        sports.sort(sportSortFunc).map(function (sport) {
            renderSportsName.push(_this.renderSport(sport));
        });
        var sportName = this.props.intl.formatMessage(messages.grid_all_sports);
        if (sportId && sportId !== 0) {
            sports = sports.filter(function (s) {
                return s.get('id') === sportId;
            });
            sportName = sports.get(sportId).get('name');
        }
        sports.sort(sportSortFunc).map(function (sport) {
            renderSports.push(_jsx(Sport, { sport: sport, timeFilter: date }, sport.get('id')));
        });
        var dateDDCls = showTimeFilterDD ? ' show-dropdown' : '';
        var sportDDCls = showSportDD ? ' show-dropdown' : '';
        return (_jsxs("div", __assign({ className: 'blc_calendar clearfix' }, { children: [_jsx("div", __assign({ className: 'tabmenu_calendar' }, { children: _jsxs("ul", { children: [_jsx("li", __assign({ className: 'date-text' }, { children: moment(date).format('DD/MM/YYYY') })), _jsxs("li", __assign({ className: 'date-item', ref: this.setWrapperRef }, { children: [_jsx("a", __assign({ href: '#', id: 'date', name: 'showTimeFilterDD', onClick: this.onDropdownClick }, { children: timeFilter })), _jsxs("ul", __assign({ ref: function (node) { return _this.node = node; }, className: "date-dropdown".concat(dateDDCls) }, { children: [_jsx("li", { children: _jsx("a", __assign({ href: '#', id: '0', onClick: this.onChangeDate }, { children: this.props.intl.formatMessage(messages.grid_today) })) }), _jsx("li", __assign({ className: 'calendar-tomorrow' }, { children: _jsx("a", __assign({ href: '#', id: '1', onClick: this.onChangeDate }, { children: this.props.intl.formatMessage(messages.grid_tomorrow) })) })), _jsx("li", { children: _jsx("a", __assign({ href: '#', id: '2', onClick: this.onChangeDate }, { children: this.props.intl.formatMessage(messages.grid_tomorrow_2) })) })] }))] })), _jsxs("li", __assign({ className: 'calendar-allsport-title', ref: this.setWrapperRef }, { children: [_jsx("a", __assign({ className: 'dropdown-toggle', id: 'sport', href: '#', name: 'showSportDD', onClick: this.onDropdownClick }, { children: sportName })), _jsxs("ul", __assign({ className: "sport-dropdown".concat(sportDDCls) }, { children: [renderSportsName, _jsx("li", __assign({ className: 'sport show' }, { children: _jsx("a", __assign({ href: '#', onClick: this.onSportChange, name: '0' }, { children: this.props.intl.formatMessage(messages.grid_all_sports) })) }), 0)] }))] }))] }) })), renderSports] })));
    };
    return Timetable;
}(React.Component));
Timetable.propTypes = {
    sports: PropTypes.object.isRequired,
    leagues: PropTypes.object.isRequired,
    intl: PropTypes.object.isRequired
};
var mapStateToProps = function (state) {
    return {
        sports: state.application.getIn(['timetable', 'sports']),
        leagues: state.application.getIn(['timetable', 'leagues'])
    };
};
Timetable = connect(mapStateToProps)(Timetable);
export default injectIntl(Timetable);



// WEBPACK FOOTER //
// ./src/components/grid/live/timetable/Timetable.jsx